module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAcCAMAAAAkyw3kAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABIUExURf///////////////////////////0dwTP////////////////////////////////+dIv+dJP+zUP/s1f/dsf+7Zv/Fev/79xfcT14AAAAPdFJOU4EsUGjDBusAflqJILpAmSFN64wAAADKSURBVDjLldTZDoQgDEDRglarqIC4/P+fDuiMOC5Fa3w7uYmxAFgX+m4aVW4DnWamwAgLDuosQtZpeArrF0VUbSVVCnYyAyACEDvo3Bnm4J1/IYtwMKYfruBCaYNzb4yxR5p7sbAIdYAnmtOp+IUHel9cKV+0GzSOLVr7o3ZOFP0TZnQ6WfTP6FJfHdw/uy5Ox9pdcZ4md/Gvl2LYC357GqK1KFP7iErIjKjCBxuOJeKbM8OfQoqwYWEboeCS9e4CKLGt7kbEG6X8APjVNm9Ao5YkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/video_icon2.png
// module id = De5K
// module chunks = 34